var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmericanFootball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_6793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0H3C1.34279 0 0 1.34367 0 3.00088V6.00088C0 6.65789 0.0399023 7.30647 0.109219 7.9473C2.19633 7.93172 4.15711 7.1151 5.63584 5.63672C7.11334 4.15922 7.93172 2.19844 7.94643 0.109219C7.30652 0.0399023 6.65789 0 6 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8906 16.0548C21.8029 16.0695 19.8427 16.8861 18.364 18.3642C16.8865 19.8417 16.0693 21.8019 16.0537 23.8917C16.6933 23.9601 17.3407 24 17.9998 24H20.9986C22.6561 24 23.9998 22.6563 23.9998 21V18C23.9998 17.343 23.9599 16.6935 23.8906 16.0548Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92998 0.443382C9.72777 5.5977 5.59498 9.72657 0.443359 9.92971C1.95625 16.7109 7.28729 22.0449 14.0703 23.5566C14.2725 18.402 18.4065 14.2743 23.5569 14.0712C22.0443 7.29 16.7133 1.95598 9.92998 0.443382ZM16.2426 14.829L14.8284 16.2435L13.4141 14.829L12.0003 16.2435L10.5863 14.829L12.0003 13.415L10.5863 12.0008L9.17213 13.415L7.75703 12.0008L9.17213 10.5869L7.75703 9.17268L9.17213 7.75758L10.5863 9.17268L12.0003 7.75758L13.4142 9.17268L12.0003 10.587L13.4142 12.0009L14.8284 10.587L16.2426 12.0009L14.8284 13.4152L16.2426 14.829Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_6793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanFootball);
export default __webpack_public_path__ + "static/media/american_football.f09e2b9297e548ae8ea6cb9c08d276d5.svg";
export { ForwardRef as ReactComponent };